import React from 'react';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import { Helmet } from '@dr.pogodin/react-helmet';

const QMISchema = ({ fields }) => {
  const script = getFieldValue(fields, 'script');

  return (
    <Helmet>
      <script defer type='application/ld+json'>
        {JSON.stringify(script)}
      </script>
    </Helmet>
  );
};

export default QMISchema;
